import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerAdminService } from "../../../services/api/consumer-admin.service";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class CreditCardChargeEffects {
	charge = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.creditCard.charge),
			switchMap((action) =>
				this.consumerAdminService.chargeCreditCard(_.omit(action, "type")).pipe(
					map(() => ConsumerAdminActions.creditCard.chargeSuccess()),
					catchError((error) =>
						of(ConsumerAdminActions.creditCard.chargeFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerAdminService: ConsumerAdminService
	) {}
}
